var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._g({staticClass:"iconfont icon-collapse g-df-c g-cursor-pointer",class:_vm.collapse ? 'iconzhankai' : 'iconshouqi'},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }